// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as InputField$OrcaPaymentPage from "./Components/InputField.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./Utilities/RecoilAtoms.bs.js";
import * as FormViewTabs$OrcaPaymentPage from "./FormViewTabs.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./Utilities/PaymentUtils.bs.js";
import * as DropdownField$OrcaPaymentPage from "./Components/DropdownField.bs.js";
import * as CardValidations$OrcaPaymentPage from "../shared-code/sdk-utils/sdk-utils/validation/CardValidations.bs.js";
import * as FormViewJourney$OrcaPaymentPage from "./FormViewJourney.bs.js";
import * as PaymentMethodCollectUtils$OrcaPaymentPage from "./Utilities/PaymentMethodCollectUtils.bs.js";

function CollectWidget(props) {
  var formLayout = props.formLayout;
  var handleSubmit = props.handleSubmit;
  var primaryTheme = props.primaryTheme;
  var availablePaymentMethodTypes = props.availablePaymentMethodTypes;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var constantString = match.constantString;
  var localeString = match.localeString;
  var config = match.config;
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.paymentMethodCollectOptionAtom);
  var enabledPaymentMethodsWithDynamicFields = match$1.enabledPaymentMethodsWithDynamicFields;
  var match$2 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.payoutDynamicFieldsAtom);
  var setPayoutDynamicFields = match$2[1];
  var match$3 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.formDataAtom);
  var setFormData = match$3[1];
  var formData = match$3[0];
  var match$4 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.paymentMethodTypeAtom);
  var activePmt = match$4[0];
  var match$5 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.validityDictAtom);
  var setValidityDict = match$5[1];
  var validityDict = match$5[0];
  var paymentMethodListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var supportedCardBrands = React.useMemo((function () {
          return PaymentUtils$OrcaPaymentPage.getSupportedCardBrands(paymentMethodListValue);
        }), [paymentMethodListValue]);
  var match$6 = React.useState(function () {
        return PaymentMethodCollectUtils$OrcaPaymentPage.defaultView(formLayout);
      });
  var setCurrentView = match$6[1];
  var currentView = match$6[0];
  React.useEffect((function () {
          setCurrentView(function (param) {
                return PaymentMethodCollectUtils$OrcaPaymentPage.defaultView(formLayout);
              });
        }), [formLayout]);
  React.useEffect((function () {
          Core__Option.map(Core__Option.flatMap(PaymentMethodCollectUtils$OrcaPaymentPage.getPayoutDynamicFields(enabledPaymentMethodsWithDynamicFields, activePmt), (function (payoutDynamicFields) {
                      setPayoutDynamicFields(function (param) {
                            return payoutDynamicFields;
                          });
                      return PaymentMethodCollectUtils$OrcaPaymentPage.getDefaultsAndValidity(payoutDynamicFields, supportedCardBrands);
                    })), (function (param) {
                  var validity = param[1];
                  var values = param[0];
                  setFormData(function (param) {
                        return values;
                      });
                  setValidityDict(function (param) {
                        return validity;
                      });
                }));
        }), [activePmt]);
  var setFormData$1 = function (key, value) {
    setFormData(function (prevDict) {
          var copy = Object.assign({}, prevDict);
          copy[key] = value;
          return copy;
        });
  };
  var setValidityDictVal = function (key, value) {
    setValidityDict(function (prevDict) {
          var copy = Object.assign({}, prevDict);
          copy[key] = value;
          return copy;
        });
  };
  var inputRef = React.useRef(null);
  var cardNumberRef = React.useRef(null);
  var cardExpRef = React.useRef(null);
  var cardHolderRef = React.useRef(null);
  var routingNumberRef = React.useRef(null);
  var achAccNumberRef = React.useRef(null);
  var bacsSortCodeRef = React.useRef(null);
  var bacsAccNumberRef = React.useRef(null);
  var ibanRef = React.useRef(null);
  var sepaBicRef = React.useRef(null);
  var bankNameRef = React.useRef(null);
  var bankCityRef = React.useRef(null);
  var countryCodeRef = React.useRef(null);
  var renderDropdownTemplate = function (field) {
    if (field.TAG !== "BillingAddress") {
      return null;
    }
    var countries = field._0;
    if (typeof countries !== "object") {
      return null;
    }
    if (countries.TAG !== "AddressCountry") {
      return null;
    }
    var countries$1 = countries._0;
    var key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey(field);
    var value = Core__Option.getOr(formData[key], "");
    if (countries$1.length > 0) {
      return React.createElement("div", {
                  key: key
                }, React.createElement(DropdownField$OrcaPaymentPage.make, {
                      appearance: config.appearance,
                      value: value,
                      setValue: (function (getVal) {
                          var updatedValue = getVal();
                          var validCardBrand = CardUtils$OrcaPaymentPage.getFirstValidCardSchemeFromPML(updatedValue, Core__Option.getOr(supportedCardBrands, []));
                          var newCardBrand = validCardBrand !== undefined ? validCardBrand : CardUtils$OrcaPaymentPage.getCardBrand(updatedValue);
                          var isValid = PaymentMethodCollectUtils$OrcaPaymentPage.calculateValidity(field, updatedValue, newCardBrand, false);
                          setValidityDictVal(key, isValid);
                          if (Core__Option.getOr(isValid, false)) {
                            return setFormData$1(key, updatedValue);
                          }
                          
                        }),
                      fieldName: PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldLabel(field, localeString),
                      options: DropdownField$OrcaPaymentPage.updateArrayOfStringToOptionsTypeArray(countries$1),
                      disabled: false
                    }));
    } else {
      return null;
    }
  };
  var renderInputTemplate = function (field) {
    var inputRef$1;
    if (field.TAG === "BillingAddress") {
      inputRef$1 = inputRef;
    } else {
      var tmp = field._0;
      if (typeof tmp !== "object") {
        switch (tmp) {
          case "CardNumber" :
              inputRef$1 = cardNumberRef;
              break;
          case "CardHolderName" :
              inputRef$1 = cardHolderRef;
              break;
          case "ACHRoutingNumber" :
              inputRef$1 = routingNumberRef;
              break;
          case "ACHAccountNumber" :
              inputRef$1 = achAccNumberRef;
              break;
          case "BacsSortCode" :
              inputRef$1 = bacsSortCodeRef;
              break;
          case "BacsAccountNumber" :
              inputRef$1 = bacsAccNumberRef;
              break;
          case "SepaIban" :
              inputRef$1 = ibanRef;
              break;
          case "SepaBic" :
              inputRef$1 = sepaBicRef;
              break;
          case "ACHBankName" :
          case "BacsBankName" :
          case "SepaBankName" :
              inputRef$1 = bankNameRef;
              break;
          case "ACHBankCity" :
          case "BacsBankCity" :
          case "SepaBankCity" :
              inputRef$1 = bankCityRef;
              break;
          case "SepaCountryCode" :
              inputRef$1 = countryCodeRef;
              break;
          default:
            inputRef$1 = inputRef;
        }
      } else {
        inputRef$1 = cardExpRef;
      }
    }
    var pattern = Core__Option.getOr(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldCharacterPattern(field), /.*/).source;
    var key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey(field);
    var value = Core__Option.getOr(formData[key], "");
    var isValid = Core__Option.flatMap(validityDict[key], (function (key) {
            return key;
          }));
    var match = isValid !== undefined && !isValid ? [
        PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataErrorString(field, value, localeString),
        "text-xs text-red-950"
      ] : [
        "",
        ""
      ];
    return React.createElement(InputField$OrcaPaymentPage.make, {
                id: key,
                setIsValid: (function (updatedValidityFn) {
                    setValidityDictVal(key, updatedValidityFn());
                  }),
                value: value,
                onChange: (function ($$event) {
                    var value = $$event.target.value;
                    var inputType = $$event.target.type;
                    var match;
                    var exit = 0;
                    var exit$1 = 0;
                    var exit$2 = 0;
                    if (value === "") {
                      match = [
                        true,
                        ""
                      ];
                    } else if (field.TAG === "BillingAddress") {
                      exit$2 = 3;
                    } else {
                      var tmp = field._0;
                      if (typeof tmp !== "object") {
                        if (tmp === "CardNumber") {
                          var exit$3 = 0;
                          switch (inputType) {
                            case "number" :
                            case "tel" :
                                exit$3 = 4;
                                break;
                            default:
                              exit$2 = 3;
                          }
                          if (exit$3 === 4) {
                            var cardType = CardUtils$OrcaPaymentPage.getCardType(Core__Option.getOr(formData[PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey({
                                              TAG: "PayoutMethodData",
                                              _0: "CardBrand"
                                            })], ""));
                            var formattedCardNumber = CardUtils$OrcaPaymentPage.formatCardNumber(value, cardType);
                            var clearCardNumber = CardValidations$OrcaPaymentPage.clearSpaces(formattedCardNumber);
                            var cardTypeStr = CardUtils$OrcaPaymentPage.getCardStringFromType(cardType);
                            if (CardUtils$OrcaPaymentPage.focusCardValid(clearCardNumber, cardTypeStr)) {
                              CardUtils$OrcaPaymentPage.handleInputFocus(cardNumberRef, cardExpRef);
                            }
                            if (CardUtils$OrcaPaymentPage.maxCardLength(cardTypeStr) === clearCardNumber.length) {
                              setValidityDictVal("card.cardNumber", PaymentMethodCollectUtils$OrcaPaymentPage.calculateValidity(field, value, cardTypeStr, Caml_option.some(undefined)));
                            } else {
                              setValidityDictVal("card.cardNumber", true);
                            }
                            match = [
                              true,
                              formattedCardNumber
                            ];
                          }
                          
                        } else {
                          exit$2 = 3;
                        }
                      } else {
                        var exit$4 = 0;
                        switch (inputType) {
                          case "number" :
                          case "tel" :
                              exit$4 = 4;
                              break;
                          default:
                            exit$2 = 3;
                        }
                        if (exit$4 === 4) {
                          var formattedExpiry = CardValidations$OrcaPaymentPage.formatCardExpiryNumber(value);
                          var isCardExpiryValid = CardUtils$OrcaPaymentPage.isExipryValid(formattedExpiry);
                          if (isCardExpiryValid) {
                            CardUtils$OrcaPaymentPage.handleInputFocus(cardExpRef, cardHolderRef);
                          }
                          if (formattedExpiry.length === PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldMaxLength(field)) {
                            setValidityDictVal("card.cardExp", isCardExpiryValid);
                          } else {
                            setValidityDictVal("card.cardExp", true);
                          }
                          match = [
                            true,
                            formattedExpiry
                          ];
                        }
                        
                      }
                    }
                    if (exit$2 === 3) {
                      var exit$5 = 0;
                      switch (inputType) {
                        case "number" :
                        case "tel" :
                            exit$5 = 4;
                            break;
                        default:
                          if (field.TAG === "BillingAddress") {
                            exit = 1;
                          } else {
                            var tmp$1 = field._0;
                            if (typeof tmp$1 !== "object") {
                              switch (tmp$1) {
                                case "SepaIban" :
                                case "SepaBic" :
                                    exit$1 = 2;
                                    break;
                                default:
                                  exit = 1;
                              }
                            } else {
                              exit = 1;
                            }
                          }
                      }
                      if (exit$5 === 4) {
                        try {
                          var bigIntValue = BigInt(value);
                          match = [
                            true,
                            bigIntValue.toString()
                          ];
                        }
                        catch (exn){
                          match = [
                            false,
                            value
                          ];
                        }
                      }
                      
                    }
                    if (exit$1 === 2) {
                      if (inputType === "text") {
                        match = [
                          true,
                          value.toUpperCase()
                        ];
                      } else {
                        exit = 1;
                      }
                    }
                    if (exit === 1) {
                      match = Core__Option.mapOr(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldCharacterPattern(field), [
                            true,
                            value
                          ], (function (regex) {
                              if (regex.test(value)) {
                                return [
                                        true,
                                        value
                                      ];
                              } else {
                                return [
                                        false,
                                        value
                                      ];
                              }
                            }));
                    }
                    if (!match[0]) {
                      return ;
                    }
                    var updatedValue = match[1];
                    if (field.TAG !== "BillingAddress") {
                      var tmp$2 = field._0;
                      if (typeof tmp$2 !== "object" && tmp$2 === "CardNumber") {
                        var validCardBrand = CardUtils$OrcaPaymentPage.getFirstValidCardSchemeFromPML(updatedValue, Core__Option.getOr(supportedCardBrands, []));
                        var newCardBrand = validCardBrand !== undefined ? validCardBrand : CardUtils$OrcaPaymentPage.getCardBrand(updatedValue);
                        setFormData$1(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey({
                                  TAG: "PayoutMethodData",
                                  _0: "CardBrand"
                                }), newCardBrand);
                      }
                      
                    }
                    setFormData$1(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey(field), updatedValue);
                  }),
                onBlur: (function (ev) {
                    var value = ev.target.value;
                    var validCardBrand = CardUtils$OrcaPaymentPage.getFirstValidCardSchemeFromPML(value, Core__Option.getOr(supportedCardBrands, []));
                    var newCardBrand = validCardBrand !== undefined ? validCardBrand : CardUtils$OrcaPaymentPage.getCardBrand(value);
                    var isValid = PaymentMethodCollectUtils$OrcaPaymentPage.calculateValidity(field, value, newCardBrand, Caml_option.some(undefined));
                    setValidityDictVal(key, isValid);
                  }),
                errorString: match[0],
                errorStringClasses: match[1],
                fieldName: PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldLabel(field, localeString),
                type_: PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldInputType(field),
                maxLength: PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldMaxLength(field),
                pattern: pattern,
                placeholder: PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldPlaceholder(field, localeString, constantString),
                className: "min-w-full border mt-1.5 px-2.5 py-2 rounded-md border-jp-gray-200",
                inputRef: inputRef$1,
                isFocus: true,
                labelClassName: "text-sm mt-2.5 text-jp-gray-800",
                paymentType: "PaymentMethodCollectElement"
              });
  };
  var renderAddressForm = function (addressFields) {
    return addressFields.map(function (field, index) {
                  var match = field.fieldType;
                  var match$1 = field.value;
                  var tmp;
                  if (typeof match !== "object") {
                    switch (match) {
                      case "Email" :
                          tmp = match$1 !== undefined ? null : renderInputTemplate({
                                  TAG: "BillingAddress",
                                  _0: "Email"
                                });
                          break;
                      case "CountryCode" :
                          tmp = match$1 !== undefined ? null : renderInputTemplate({
                                  TAG: "BillingAddress",
                                  _0: "CountryCode"
                                });
                          break;
                      case "PhoneNumber" :
                          tmp = match$1 !== undefined ? null : renderInputTemplate({
                                  TAG: "BillingAddress",
                                  _0: "PhoneNumber"
                                });
                          break;
                      case "PhoneCountryCode" :
                          tmp = match$1 !== undefined ? null : renderInputTemplate({
                                  TAG: "BillingAddress",
                                  _0: "PhoneCountryCode"
                                });
                          break;
                      case "AddressLine1" :
                          tmp = match$1 !== undefined ? null : renderInputTemplate({
                                  TAG: "BillingAddress",
                                  _0: "AddressLine1"
                                });
                          break;
                      case "AddressLine2" :
                          tmp = match$1 !== undefined ? null : renderInputTemplate({
                                  TAG: "BillingAddress",
                                  _0: "AddressLine2"
                                });
                          break;
                      case "AddressCity" :
                          tmp = match$1 !== undefined ? null : renderInputTemplate({
                                  TAG: "BillingAddress",
                                  _0: "AddressCity"
                                });
                          break;
                      case "AddressState" :
                          tmp = match$1 !== undefined ? null : renderInputTemplate({
                                  TAG: "BillingAddress",
                                  _0: "AddressState"
                                });
                          break;
                      case "AddressPincode" :
                          tmp = match$1 !== undefined ? null : renderInputTemplate({
                                  TAG: "BillingAddress",
                                  _0: "AddressPincode"
                                });
                          break;
                      
                    }
                  } else {
                    tmp = match.TAG === "FullName" ? (
                        match._0 === "FirstName" && match$1 === undefined ? renderInputTemplate({
                                TAG: "BillingAddress",
                                _0: {
                                  TAG: "FullName",
                                  _0: "FirstName"
                                }
                              }) : null
                      ) : (
                        match$1 !== undefined ? null : renderDropdownTemplate({
                                TAG: "BillingAddress",
                                _0: {
                                  TAG: "AddressCountry",
                                  _0: match._0
                                }
                              })
                      );
                  }
                  return JsxPPXReactSupportU.createElementWithKey(index.toString(), React.Fragment, {
                              children: tmp
                            });
                }).filter(function (ele) {
                return ele !== null;
              });
  };
  var renderPayoutMethodForm = function (payoutMethodFields) {
    return payoutMethodFields.map(function (payoutMethodField, index) {
                  var match = payoutMethodField.fieldType;
                  var match$1 = payoutMethodField.value;
                  var tmp;
                  if (typeof match !== "object") {
                    switch (match) {
                      case "CardNumber" :
                          tmp = renderInputTemplate({
                                TAG: "PayoutMethodData",
                                _0: "CardNumber"
                              });
                          break;
                      case "CardHolderName" :
                          tmp = match$1 !== undefined ? null : renderInputTemplate({
                                  TAG: "PayoutMethodData",
                                  _0: "CardHolderName"
                                });
                          break;
                      case "ACHRoutingNumber" :
                          tmp = renderInputTemplate({
                                TAG: "PayoutMethodData",
                                _0: "ACHRoutingNumber"
                              });
                          break;
                      case "ACHAccountNumber" :
                          tmp = renderInputTemplate({
                                TAG: "PayoutMethodData",
                                _0: "ACHAccountNumber"
                              });
                          break;
                      case "BacsSortCode" :
                          tmp = renderInputTemplate({
                                TAG: "PayoutMethodData",
                                _0: "BacsSortCode"
                              });
                          break;
                      case "BacsAccountNumber" :
                          tmp = renderInputTemplate({
                                TAG: "PayoutMethodData",
                                _0: "BacsAccountNumber"
                              });
                          break;
                      case "SepaIban" :
                          tmp = renderInputTemplate({
                                TAG: "PayoutMethodData",
                                _0: "SepaIban"
                              });
                          break;
                      case "SepaBic" :
                          tmp = renderInputTemplate({
                                TAG: "PayoutMethodData",
                                _0: "SepaBic"
                              });
                          break;
                      case "PaypalMail" :
                          tmp = renderInputTemplate({
                                TAG: "PayoutMethodData",
                                _0: "PaypalMail"
                              });
                          break;
                      case "PaypalMobNumber" :
                          tmp = renderInputTemplate({
                                TAG: "PayoutMethodData",
                                _0: "PaypalMobNumber"
                              });
                          break;
                      case "PixKey" :
                          tmp = renderInputTemplate({
                                TAG: "PayoutMethodData",
                                _0: "PixKey"
                              });
                          break;
                      case "VenmoMobNumber" :
                          tmp = renderInputTemplate({
                                TAG: "PayoutMethodData",
                                _0: "VenmoMobNumber"
                              });
                          break;
                      case "InteracEmail" :
                          tmp = renderInputTemplate({
                                TAG: "PayoutMethodData",
                                _0: "InteracEmail"
                              });
                          break;
                      default:
                        tmp = null;
                    }
                  } else {
                    tmp = match._0 === "CardExpMonth" ? renderInputTemplate({
                            TAG: "PayoutMethodData",
                            _0: {
                              TAG: "CardExpDate",
                              _0: "CardExpMonth"
                            }
                          }) : null;
                  }
                  return JsxPPXReactSupportU.createElementWithKey(index.toString(), React.Fragment, {
                              children: tmp
                            });
                }).filter(function (ele) {
                return ele !== null;
              });
  };
  var tmp;
  tmp = currentView.TAG === "Journey" ? React.createElement(FormViewJourney$OrcaPaymentPage.make, {
          availablePaymentMethods: props.availablePaymentMethods,
          availablePaymentMethodTypes: availablePaymentMethodTypes,
          primaryTheme: primaryTheme,
          handleSubmit: handleSubmit,
          enabledPaymentMethodsWithDynamicFields: enabledPaymentMethodsWithDynamicFields,
          journeyView: currentView._0,
          renderAddressForm: renderAddressForm,
          renderPayoutMethodForm: renderPayoutMethodForm
        }) : React.createElement(FormViewTabs$OrcaPaymentPage.make, {
          availablePaymentMethodTypes: availablePaymentMethodTypes,
          primaryTheme: primaryTheme,
          handleSubmit: handleSubmit,
          tabsView: currentView._0,
          renderAddressForm: renderAddressForm,
          renderPayoutMethodForm: renderPayoutMethodForm
        });
  return React.createElement("div", {
              className: "flex flex-col h-min p-6 items-center lg:rounded lg:shadow-lg lg:p-10 lg:min-w-[400px]"
            }, tmp);
}

var make = CollectWidget;

var $$default = CollectWidget;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
